/** Shared request IDs used by the workbook and building handover workspace. */
export const buildingHandoverCatalogue = [
    {
        "pack": "Standard",
        "category": "Authority",
        "title": "Appointment and transfer arrangements",
        "request": "Client authority, outgoing and incoming contacts, agreed termination/start dates, transfer scope and outstanding responsibilities.",
        "id": "STD-001",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Authority",
        "title": "Client and ownership structure",
        "request": "Freeholder, RMC/RTM, company numbers, registered offices, directors, delegated authorities and estate relationships.",
        "id": "STD-002",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Authority",
        "title": "Management agreement and service scope",
        "request": "Current agreement, variations, service specification, fees, spending limits and approvals.",
        "id": "STD-003",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Authority",
        "title": "Company and governance records",
        "request": "Constitution, registers, relevant resolutions, minutes, filings and next filing deadlines, where held within the appointment.",
        "id": "STD-004",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Authority",
        "title": "Building description and boundaries",
        "request": "Addresses, site/block/unit schedule, plans, shared areas, access rights, parking and retained areas.",
        "id": "STD-005",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Authority",
        "title": "Leases and legal instruments",
        "request": "Governing leases, sample variations, deeds, licences, transfers, title information and known interpretation issues.",
        "id": "STD-006",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Authority",
        "title": "Responsibility matrix",
        "request": "Who maintains and pays for each area/system, shared estate interfaces and unresolved responsibility disputes.",
        "id": "STD-007",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Authority",
        "title": "HRB applicability assessment",
        "request": "Recorded occupied-building HRB status, jurisdiction, height/storeys, residential units, assessment basis and assessor. Do not infer status from height alone.",
        "id": "STD-008",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "People",
        "title": "Leaseholder and unit schedule",
        "request": "Unit IDs, ownership, correspondence addresses, contact preferences and effective dates. Supply structured data where available.",
        "id": "STD-009",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "People",
        "title": "Occupier and emergency contacts",
        "request": "Current contacts held for management purposes, emergency arrangements and known contact gaps. Transfer securely.",
        "id": "STD-010",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "People",
        "title": "Resident support arrangements",
        "request": "Relevant assistance arrangements and emergency plans, where held and applicable. Transfer sensitive details separately with restricted access.",
        "id": "STD-011",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "People",
        "title": "Live sales, lettings and consents",
        "request": "Pending enquiries, notices, certificates, consents, licences and solicitor correspondence with deadlines.",
        "id": "STD-012",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "People",
        "title": "Staff and employment arrangements",
        "request": "Staff, payroll/pension provider contacts, roles, employment liabilities and transfer advice where staff are affected. Use a restricted transfer.",
        "id": "STD-013",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Finance",
        "title": "Financial cut-off and accounting basis",
        "request": "Financial year, accounting basis, ledger cut-off, service charge schedules, apportionments and responsibility for closing periods.",
        "id": "STD-014",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Finance",
        "title": "Current budget and demands",
        "request": "Approved budget, demand schedule, issued demands, balancing charges and relevant approvals.",
        "id": "STD-015",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Finance",
        "title": "Prior accounts and open years",
        "request": "Latest signed/certified accounts, supporting schedules, prior comparative records and unclosed periods with owners and dates.",
        "id": "STD-016",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Finance",
        "title": "Unit ledgers and aged debtors",
        "request": "Transaction-level unit ledgers, receipts, arrears/credits and allocation history tied to the cut-off.",
        "id": "STD-017",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Finance",
        "title": "Arrears recovery and payment plans",
        "request": "Current recovery stage, disputes, instalments, solicitors, court deadlines and who continues each case.",
        "id": "STD-018",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Finance",
        "title": "Bank accounts and reconciliation",
        "request": "Account identifiers, statements, cash book, reconciliations, unreconciled items, mandates and account ownership. No passwords in this workbook.",
        "id": "STD-019",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Finance",
        "title": "Funds transfer and retained commitments",
        "request": "Amounts and dates to transfer, reserves by fund, sums retained, reasons, committed payments and final settlement timetable. Verify payment instructions independently.",
        "id": "STD-020",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Finance",
        "title": "Creditors and unpaid invoices",
        "request": "Aged creditors, invoice copies, disputed sums, accruals, approvals and scheduled payments.",
        "id": "STD-021",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Finance",
        "title": "Reserves and planned expenditure",
        "request": "Reserve/sinking fund balances, movements, restrictions and commitments linked to planned works.",
        "id": "STD-022",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Finance",
        "title": "Other balances and income",
        "request": "Prepayments, deposits, insurance proceeds, rents and other funds administered under the appointment.",
        "id": "STD-023",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Finance",
        "title": "Final accounts and reconciliation timetable",
        "request": "Who closes each period, supplies final ledgers, resolves differences and transfers the balance. Record agreed dates.",
        "id": "STD-024",
        "stage": "After transfer"
    },
    {
        "pack": "Standard",
        "category": "Insurance",
        "title": "Current policy and cover",
        "request": "Policy/schedule, insurer/broker, cover dates, sums insured, exclusions, excesses, endorsements and premium/payment position.",
        "id": "STD-025",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Insurance",
        "title": "Valuation and insurance requirements",
        "request": "Latest reinstatement valuation, next review, inspection requirements and outstanding insurer conditions.",
        "id": "STD-026",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Insurance",
        "title": "Claims and incident history",
        "request": "Open claims, reference numbers, correspondence, settlement funds, excess recovery and notification deadlines.",
        "id": "STD-027",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Safety",
        "title": "Immediate risks and interim measures",
        "request": "Known serious defects, restrictions, temporary measures, emergency contacts and urgent actions. Escalate directly as well as recording here.",
        "id": "STD-028",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Safety",
        "title": "Fire risk assessment and actions",
        "request": "Latest assessment, earlier relevant findings, action register, completion evidence, review date and assessor.",
        "id": "STD-029",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Safety",
        "title": "Fire strategy and emergency arrangements",
        "request": "Available strategy, evacuation arrangements, resident instructions, emergency plans and fire service information.",
        "id": "STD-030",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Safety",
        "title": "Fire doors and compartmentation",
        "request": "Door registers, inspections, surveys, defects, remedial works and available completion evidence, as applicable.",
        "id": "STD-031",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Safety",
        "title": "External walls and fire spread",
        "request": "Available external wall appraisals, construction information, assessments, remediation and interim measures, as applicable.",
        "id": "STD-032",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Safety",
        "title": "Fire systems and maintenance",
        "request": "Registers, specifications, test/maintenance reports and defects for alarms, lighting, smoke control, suppression, risers and firefighting equipment present.",
        "id": "STD-033",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Safety",
        "title": "Structural condition and defects",
        "request": "Surveys, structural concerns, monitoring, restrictions, temporary works and outstanding recommendations.",
        "id": "STD-034",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Safety",
        "title": "Asbestos information",
        "request": "Register, surveys, management plan, access limitations and outstanding actions where applicable.",
        "id": "STD-035",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Safety",
        "title": "Water hygiene and Legionella",
        "request": "Assessments, schematics, monitoring, test results, responsible contractors and outstanding actions where applicable.",
        "id": "STD-036",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Safety",
        "title": "Electrical and gas safety",
        "request": "Communal electrical reports, gas records, defects, remedial evidence and next inspections where applicable.",
        "id": "STD-037",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Safety",
        "title": "Other safety assessments",
        "request": "General risk assessments, hazardous materials, work equipment, access systems and other applicable inspections.",
        "id": "STD-038",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Safety",
        "title": "Enforcement and regulator correspondence",
        "request": "Notices, inspection correspondence, undertakings, prosecution/dispute history and outstanding deadlines.",
        "id": "STD-039",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Assets and services",
        "title": "Asset register and O&M information",
        "request": "Plant/equipment list, location, make/model, warranties, manuals, service history and ownership.",
        "id": "STD-040",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Assets and services",
        "title": "Lifts and lifting equipment",
        "request": "Maintenance contract, examination reports, defects, rescue arrangements and next service/examination where present.",
        "id": "STD-041",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Assets and services",
        "title": "Communal heating and hot water",
        "request": "Plant, metering, billing, supply contracts, maintenance, resident arrangements and unresolved issues where present.",
        "id": "STD-042",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Assets and services",
        "title": "Supplier contracts and contacts",
        "request": "Current contracts, scope, prices, expiry/notice dates, service schedules, disputes and assignment/termination arrangements.",
        "id": "STD-043",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Assets and services",
        "title": "Utilities and meter readings",
        "request": "Supply addresses, meter IDs, account references, tariffs, contracts, bills, balances and agreed transfer readings.",
        "id": "STD-044",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Assets and services",
        "title": "Maintenance and inspection calendar",
        "request": "Recurring services, inspections, statutory reviews and tasks falling due around transfer.",
        "id": "STD-045",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Assets and services",
        "title": "Keys, fobs and physical access",
        "request": "Inventory, labels, keyholder contacts, access rights and physical receipt arrangements. Transfer codes by a separate secure route.",
        "id": "STD-046",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Assets and services",
        "title": "Systems and digital access",
        "request": "Building-owned portals, software, CCTV/access administration, licences and account transfer arrangements. No credentials in this workbook.",
        "id": "STD-047",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Assets and services",
        "title": "Plans, drawings and warranties",
        "request": "As-built drawings, manuals, health and safety file, guarantees, completion certificates and known gaps.",
        "id": "STD-048",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Live management",
        "title": "Open repairs and instructions",
        "request": "Job reference, issue, location, contractor, stage, approval, spend, next action, owner and due date.",
        "id": "STD-049",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Live management",
        "title": "Major works and consultations",
        "request": "Project records, specifications, tenders, consultation notices/responses, approvals, programme, funding and outstanding decisions.",
        "id": "STD-050",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Live management",
        "title": "Remediation and funding arrangements",
        "request": "Defect/remediation history, funding applications, developer/contractor undertakings and remaining conditions where applicable.",
        "id": "STD-051",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Live management",
        "title": "Complaints, disputes and litigation",
        "request": "Current position, correspondence, commitments, advisers, response/court deadlines and agreed case ownership.",
        "id": "STD-052",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Live management",
        "title": "Decisions and building history",
        "request": "Important decisions, rationale, recurring problems, failed remedies and commitments made to residents/client.",
        "id": "STD-053",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Live management",
        "title": "Upcoming events and deadlines",
        "request": "Meetings, contract notices, renewals, reporting dates and operational deadlines covering the transfer period.",
        "id": "STD-054",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Live management",
        "title": "Communications and document archive",
        "request": "Relevant correspondence and records in original formats with an index, dates and explanation of missing/restricted material.",
        "id": "STD-055",
        "stage": "Before transfer"
    },
    {
        "pack": "Standard",
        "category": "Live management",
        "title": "Transfer-day update and acknowledgement",
        "request": "Last-minute incidents, changed instructions, funds/access receipts, unresolved items and responsibility accepted by each party.",
        "id": "STD-056",
        "stage": "At transfer"
    },
    {
        "pack": "HRB",
        "category": "Status and dutyholders",
        "title": "Occupied HRB determination",
        "request": "Assessment basis, building boundaries, height/storeys, use, exclusions, jurisdiction and competent review. This schedule concerns occupied HRBs in England.",
        "id": "HRB-001",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Status and dutyholders",
        "title": "Registration and key building information",
        "request": "Current BSR registration details/reference and submitted key building information, changes and unresolved discrepancies.",
        "id": "HRB-002",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Status and dutyholders",
        "title": "Principal accountable person",
        "request": "PAP identity, legal entity, contact, authority and evidence of responsibility. A managing-agent change does not itself transfer AP/PAP duties.",
        "id": "HRB-003",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Status and dutyholders",
        "title": "Accountable persons and interfaces",
        "request": "Each AP, responsible part, contact, responsibility plans and cooperation/information-sharing arrangements.",
        "id": "HRB-004",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Status and dutyholders",
        "title": "Responsible persons and coordination",
        "request": "Fire Safety Order responsible persons and arrangements for coordinating fire and building safety duties.",
        "id": "HRB-005",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Safety management",
        "title": "Safety case and safety case report",
        "request": "Current report and supporting safety case evidence, authors, review history, known gaps and next review.",
        "id": "HRB-006",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Safety management",
        "title": "Building safety risk assessments",
        "request": "Fire spread and structural failure assessments, assumptions, specialist reports and review triggers.",
        "id": "HRB-007",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Safety management",
        "title": "Safety management arrangements",
        "request": "Policies, competent resources, inspection/maintenance controls, monitoring, change management and assurance records.",
        "id": "HRB-008",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Safety management",
        "title": "Building safety action register",
        "request": "Open and completed risk controls, owners, target dates, escalation, interim measures and closure evidence.",
        "id": "HRB-009",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Safety management",
        "title": "Building assessment certificate",
        "request": "Direction to apply, application/submissions, certificate or current stage, conditions, requests and deadlines. Do not assume every building already has a certificate.",
        "id": "HRB-010",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Safety management",
        "title": "Mandatory occurrence reporting system",
        "request": "Operating process, reporting route, responsible contacts, review history and how residents/contractors report occurrences.",
        "id": "HRB-011",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Safety management",
        "title": "Occurrence records and reports",
        "request": "Relevant incident logs, notices/reports submitted to BSR, investigations, corrective action and outstanding reporting deadlines.",
        "id": "HRB-012",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Safety management",
        "title": "BSR engagement and enforcement",
        "request": "Correspondence, inspections, compliance/other notices, requests, commitments, appeals and deadlines.",
        "id": "HRB-013",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Golden thread",
        "title": "Golden thread index and transfer",
        "request": "Digital information index, storage/access arrangements, format descriptions, custodians, version history and secure transfer/retrieval check.",
        "id": "HRB-014",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Golden thread",
        "title": "Building construction and structural information",
        "request": "Plans, structural systems, materials, design assumptions, reports and limitations relevant to the safety case.",
        "id": "HRB-015",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Golden thread",
        "title": "Fire and safety system information",
        "request": "Current strategy, compartmentation, external walls and system records linked to the core pack with document versions and known gaps.",
        "id": "HRB-016",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Golden thread",
        "title": "Building work and change records",
        "request": "Relevant approvals, controlled changes, completion records, fire safety information and handover material for works. Identify the applicable works regime separately.",
        "id": "HRB-017",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Golden thread",
        "title": "Information sharing and access records",
        "request": "Arrangements and records for information provided to APs, residents, owners, responsible persons, regulators and other relevant recipients.",
        "id": "HRB-018",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Residents and continuity",
        "title": "Resident engagement strategy",
        "request": "Current strategy, consultation/review records, communication arrangements and how residents contribute to safety decisions.",
        "id": "HRB-019",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Residents and continuity",
        "title": "Building safety complaints",
        "request": "Complaints process, current cases, responses, escalation and outstanding commitments.",
        "id": "HRB-020",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Residents and continuity",
        "title": "Resident safety information",
        "request": "Information issued to residents, translations/accessibility arrangements, versions, delivery records and outstanding requests.",
        "id": "HRB-021",
        "stage": "Before transfer"
    },
    {
        "pack": "HRB",
        "category": "Residents and continuity",
        "title": "Safety responsibilities at transfer",
        "request": "Named contacts, escalation routes, imminent deadlines, access continuity and agreed division of work during and after agent transfer.",
        "id": "HRB-022",
        "stage": "Before transfer"
    }
];
export const handoverApplicability = ['To confirm', 'Yes', 'No'];
export const handoverSupplyStatuses = ['Not supplied', 'Part supplied', 'Supplied', 'Unavailable', 'Disputed'];
export const handoverReviews = ['Not reviewed', 'Accepted', 'Clarification needed'];
export const blankBuildingHandoverRow = () => ({ applies: 'To confirm', status: 'Not supplied', reference: '', recordDate: '', holder: '', dueDate: '', nextAction: '', review: 'Not reviewed', notes: '' });
export function buildingHandoverOutstanding(row) { return row.applies === 'To confirm' || row.applies === 'Yes' && (row.status !== 'Supplied' || row.review !== 'Accepted') || row.applies === 'No' && (row.review !== 'Accepted' || !row.notes); }
//# sourceMappingURL=building-handover-pack.js.map